import { colors, fontFamily } from "../branding/generated/active-tokens";

export const mui = {
  primary: colors.brand.primary,
  primaryContrast: "#FFFFFF",
  secondary: colors.brand.secondary,
  secondaryContrast: "#000000",
  fontBody: fontFamily.body,
};
